const UiPaths = {
    Dashboard: '/dashboard/:id',
    Login: 'login',
  };
  
  export default UiPaths;